module.exports = __webpack_public_path__ + "img/_88A4397_398_400Balanced.98f7c029.jpg";